import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../components/leads/TestScoreCommentsHeader'
import LeadsCreateContent from '../components/leads/TestScoreCommentsTable'
import Footer from '../components/shared/Footer'

const VersionTable = () => {
    return (
        <>
            <PageHeader>
                <LeadsCreateHeader />
            </PageHeader>

            <div className='main-content'>
                <div className='row'>
                    <LeadsCreateContent/>
                </div>
            </div>
            
        </>
    )
}

export default VersionTable